import { createSelector } from 'reselect'

export const getProductsLoading = createSelector(
  (state) => Boolean(state && state.ads && state.ads.products && state.ads.products.isLoading),
  (isLoading) => isLoading
)
